import { ComponentStyleConfig } from "@chakra-ui/theme";

const Heading: ComponentStyleConfig = {
  variants: {
    "sub-heading": {
      as: "h2",
      fontSize: "lg",
      textAlign: "left",
    },
  },
};

export default Heading;
